import React, { useRef, useState } from "react";
import showreelImage from "../../Assets/showreelcover.jpg";
import showreelVideo from "../../Assets/showreel.mp4";
import playbutton from '../../Assets/play.png'
import "./Showreel.css";

function Showreel() {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [mousePosition, setMousePosition] = useState({
    x: 50,
    y: 50,
  });

  const handleMouseMove = (event) => {
    if (!sectionRef.current || isPlaying) return;

    const rect = sectionRef.current.getBoundingClientRect();

    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    setMousePosition({ x, y });
  };

  const handlePlay = async () => {
    if (isPlaying) return;

    setIsPlaying(true);

    requestAnimationFrame(async () => {
      if (!videoRef.current) return;

      try {
        await videoRef.current.play();
      } catch (error) {
        setIsPlaying(false);
      }
    });
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);

    if (videoRef.current) {
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <section className="showreel" id="showreel">
      <div className="showreel-container">
        <div
          ref={sectionRef}
          className={`showreel-media ${
            isPlaying ? "showreel-media-playing" : ""
          }`}
          onMouseMove={handleMouseMove}
          onClick={!isPlaying ? handlePlay : undefined}
          style={{
            "--mouse-x": `${mousePosition.x}%`,
            "--mouse-y": `${mousePosition.y}%`,
          }}
        >
          {!isPlaying && (
            <>
              <img
                src={showreelImage}
                alt="ETOE Productions Showreel"
                className="showreel-image"
              />

              <div className="showreel-overlay" />
              <div className="showreel-mouse-glow" />

            

              <button
                className="showreel-play-button"
                type="button"
                onClick={(event) => {
                  event.stopPropagation();
                  handlePlay();
                }}
                aria-label="Play ETOE Productions showreel"
              >
                <img src={playbutton} alt="play-button" />
                
              </button>

              <div className="showreel-meta">
                <span>FILM / CONTENT / DIRECTION</span>
                <span>00:37</span>
              </div>
            </>
          )}

          <video
            ref={videoRef}
            className={`showreel-video ${
              isPlaying ? "showreel-video-visible" : ""
            }`}
            src={showreelVideo}
            playsInline
            controls={isPlaying}
            preload="metadata"
            onEnded={handleVideoEnded}
          />
        </div>

        <div className="showreel-footer">
           <p>
            We blend cinematic production, creative strategy, branding, design, technology,
             and digital marketing to create powerful
             experiences that inspire audiences, strengthen brands, and drive measurable growth
          </p>

        </div>
      </div>
    </section>
  );
}

export default Showreel;